/**
 * The degree an education entry records, as the profile's Education form
 * offers it. Stored as these values in `talents.custom_fields.education[].degree`.
 *
 * A CV or LinkedIn import may store its own free text there instead ("BSc",
 * "MBA"), so a stored degree is `EducationDegree | string` — readers render a
 * known value through its translation and anything else as written.
 */
export const EDUCATION_DEGREES = ['bachelor', 'master', 'phd', 'other'] as const;

export type EducationDegree = (typeof EDUCATION_DEGREES)[number];

export function isEducationDegree(value: unknown): value is EducationDegree {
  return typeof value === 'string' && (EDUCATION_DEGREES as readonly string[]).includes(value);
}
